import { render, staticRenderFns } from "./InputCard.vue?vue&type=template&id=10edd25a&"
import script from "./InputCard.vue?vue&type=script&lang=js&"
export * from "./InputCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports